export default __webpack_public_path__ + "fb414a540d6eb073e726510f0ec11c84.wasm";